<div
  class="layout-wrapper layout-content-navbar"
  style="background-color: #f8f8ff"
>
  <!-- Hamburger Menu Button (visible on small screens) -->
  <button
    class="menu-btn"
    [ngClass]="{ 'sidebar-open': isSidebarVisible }"
    (click)="toggleSideNav()"
  >
    <i class="bx bx-chevron-right"></i>
  </button>
  <div class="layout-container d-flex">
    <div class="container-xxl flex-grow-1 container-p-y">
      <div class="row g-0">
        <!-- Side Nav for Folders -->
        <div
          class="sidebar-wrapper col-12 col-md-6 col-lg-4 col-xl-3"
          [ngClass]="{ 'show-nav': isSidebarVisible }"
        >
          <div class="sidebar-card">
            <aside
              id="layout-menu"
              class="layout-menu menu-vertical menu bg-menu-theme"
              [ngClass]="{ 'show-nav': isSidebarVisible }"
            >
              <div class="menu-inner-shadow"></div>
              <div class="menu-item">
                <div
                  class="px-6 py-3 border-bottom d-flex justify-content-between align-items-center w-100"
                >
                  <div class="d-flex align-items-center">
                    <h5 class="folder-heading mb-0">
                      {{ studyCode || "Study Template" }}
                    </h5>
                  </div>
                </div>

                <!-- Dynamic Folders List -->
                <ul class="list-group list-group-flush mt-2">
                  <li
                    class="list-group-item border-0"
                    *ngFor="let folder of template?.folders || []"
                  >
                    <!-- Folder Header -->
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                    <div class="d-flex align-items-center w-100">
                      <div
                        class="d-flex align-items-center flex-grow-1 cursor-pointer"
                        (click)="onFolderClick(folder)"
                        [ngClass]="{
                          'highlighted-folder': selectedFolderId === folder.id,
                        }"
                      >
                        <i class="menu-icon tf-icons bx bx-layout"></i>
                        <span class="text-truncate">{{ folder.name }}</span>
                      </div>
                      <div class="dropdown ms-2" *ngIf="canManageFreezeLock()">
                        <button
                          class="dropdown-btn dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          (click)="onDropdownButtonClick($event); $event.stopPropagation()"
                        >
                          <i class="bx bx-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              class="dropdown-item"
                              (click)="openFreezeModalForFolder(folder, $event)"
                            >
                              {{ folder.is_frozen ? 'Unfreeze' : 'Freeze' }}
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              (click)="openLockModalForFolder(folder, $event)"
                              [class.disabled]="folder.is_locked"
                              [style.pointer-events]="folder.is_locked ? 'none' : 'auto'"
                              [style.opacity]="folder.is_locked ? '0.6' : '1'"
                            >
                              Lock
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    </div>

                    <!-- Forms in Folder -->
                    <ul
                      class="list-group list-group-flush ps-4"
                      *ngIf="selectedFolderId === folder.id"
                    >
                      <li
                        class="list-group-item border-0 p-1 d-flex justify-content-between align-items-center"
                        *ngFor="let form of folder.forms || []"
                        [ngClass]="{
                          'highlighted-form': selectedForm === form.name,
                        }"
                        style="font-size: 13px; cursor: pointer"
                      >
                        <div
                          class="flex-grow-1 text-truncate"
                          (click)="openForm(form)"
                        >
                          {{ form.name }}
                          <i
                            *ngIf="hasPiSignatureForForm(form)"
                            class="bx bx-check-circle text-success ms-1"
                            title="PI reviewed"
                          ></i>
                        </div>
                        <div
                          class="dropdown ms-1"
                          *ngIf="isUserPI() && SignatureCheck(form)"
                          (click)="$event.stopPropagation()"
                        >
                          <button
                            class="dropdown-btn dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            (click)="onDropdownButtonClick($event); $event.stopPropagation()"
                          >
                            <i class="bx bx-dots-vertical"></i>
                          </button>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                class="dropdown-item"
                                (click)="openForm(form); openPiSignatureModal($event)"
                              >
                                PI Signature
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <!-- Empty state -->
              <div
                class="text-center py-4"
                *ngIf="
                  (!template?.folders && !loading) ||
                  (template?.folders.length === 0 && !loading)
                "
              >
                <i class="bx bx-folder-open display-6 text-muted"></i>
                <div class="text-muted small">No folders yet</div>
              </div>
            </aside>
          </div>
        </div>

        <!-- Main Content Area -->
        <div class="main-content col flex-grow-1">
          <!-- Back Button - Always Visible in Main Content -->
          <div class="mb-1" style="position: relative; display: flex; justify-content: space-between; align-items: center;">
            <button
              class="btn custom-button"
              (click)="navigateToBuildTemplates()"
            >
              Back
            </button>

            <div style="display:flex; gap: 10px; align-items:center;">
              <div *ngIf="isUserPI() && SignatureCheck(form)">
                <button
                  class="btn custom-button"
                  type="button"
                  (click)="openPiSignatureModal($event)"
                >
                  Pi Signature
                </button>
              </div>

              <div *ngIf="isUserMonitorOrDataManager()">
                <button
                  class="btn custom-button"
                  type="button"
                  (click)="openReviewMonitorHeader($event)"
                >
                  Review
                </button>
              </div>
            </div>
          </div>

          <!-- Study Information Header - Above the form -->
          <div class="new-card">
            <div class="card-content">
              <div
                class="row d-flex align-items-center justify-content-between"
              >
                <div class="col-auto">
                  <strong>Study Code:</strong> {{ studyCode }}
                </div>
                <div class="col study-name-detail">
                  <strong>Study Name:</strong>
                  <span class="study-name-text" [title]="study_name">
                    {{ study_name }}
                  </span>
                </div>
                <div class="col-auto">
                  <strong>Screening ID:</strong> {{ subjectName }}
                </div>
                <div class="col-auto">
                  <strong>Participant ID:</strong> {{ participantId }}
                </div>
                <div class="col-auto">
                  <strong>Site Location:</strong> {{ siteLocation }}
                </div>
              </div>
            </div>
          </div>

          <div class="card" *ngIf="currentForm">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <div class="d-flex align-items-center">
                <h5 class="card-title mb-0">
                  {{ currentForm.name }}
                  <i
                    *ngIf="getPiSignatureReviewed()"
                    class="bx bx-check-circle text-success ms-2"
                    title="PI reviewed"
                  ></i>
                </h5>
              </div>
            </div>
            <div class="card-body">
              <!-- Dynamic Form Fields -->
              <form
                [formGroup]="form"
                class="dynamic-form"
                *ngIf="form"
                (ngSubmit)="onSubmit()"
              >
                <div class="form-fields-grid">
                  <ng-container *ngFor="let field of fields; let i = index">
                    <!-- Title field - styled like ecrf-template (section header, no form wrapper) -->
                    <div
                      *ngIf="field.type === 'title' && shouldShowField(field)"
                      class="title-field"
                    >
                      <h5 class="section-title">{{ field.title }}</h5>
                      <p *ngIf="field.description" class="section-description">
                        {{ field.description }}
                      </p>
                    </div>
                    <!-- Regular form fields -->
                    <div
                      class="form-group-wrapper position-relative mb-2"
                      *ngIf="shouldShowField(field) && field.type !== 'title'"
                      [ngClass]="{
                        'query-open': hasOpenQueries(field.title || field.name),
                        'query-closed': hasClosedQueries(field.title || field.name) && !hasOpenQueries(field.title || field.name),
                        'instruction-field-wrapper': field.type === 'instruction'
                      }"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <label class="form-label" style="font-size: 20px; font-weight: bold;">
                          <span>{{ field.title }}</span>
                          <span
                            class="query-status-icon-wrapper"
                            *ngIf="
                              hasOpenQueries(field.title || field.name) ||
                              hasClosedQueries(field.title || field.name) ||
                              hasAnsweredQueries(field.title || field.name)
                            "
                          >
                            <i
                              *ngIf="hasOpenQueries(field.title || field.name)"
                              class="bx bxs-error-circle query-status-icon open"
                              title="Open query"
                            ></i>
                            <i
                              *ngIf="hasAnsweredQueries(field.title || field.name)"
                              class="bx bxs-message-dots query-status-icon answered"
                              title="Answered query"
                            ></i>
                            <i
                              *ngIf="
                                !hasOpenQueries(field.title || field.name) &&
                                !hasAnsweredQueries(field.title || field.name) &&
                                hasClosedQueries(field.title || field.name)
                              "
                              class="bx bxs-check-shield query-status-icon closed"
                              title="Closed query"
                            ></i>
                          </span>
                          <span *ngIf="field.required" class="text-danger ms-1"
                            >*</span
                          >
                          <span *ngIf="field.required" class="text-danger ms-1"
                            >*</span
                          >
                          <i
                            *ngIf="field.hasDependency"
                            class="bx bx-link-external ms-2 text-info"
                            title="This field has a dependency"
                            style="font-size: 14px"
                          ></i>
                          <i
                            *ngIf="hasMonitorOrDataManagerReview(field.title || field.name)"
                            class="bx bx-check-circle text-success ms-2"
                            title="Reviewed by Monitor and/or Data Manager"
                            style="font-size: 16px"
                          ></i>
                        </label>
                        <!-- Field actions - Three dots menu -->
                        <div
                          class="menu-icon"
                          *ngIf="field.type !== 'table' && field.type !== 'instruction' && field.type !== 'fixed-rows-table'"
                          (click)="openOptionsModal($event, $event.target, field)"
                        >
                          ⋮
                        </div>
                      </div>

                      <!-- Small Modal (Right-side) - Options -->
                      <div
                        class="options-modal"
                        *ngIf="isOptionsModalOpen && selectedOptionsFieldId === (field.id != null ? field.id.toString() : null)"
                        (click)="$event.stopPropagation()"
                        [ngStyle]="optionsModalStyle"
                      >
                        <div class="modal-buttons">
                          <button 
                            type="button" 
                            (click)="openModal()"
                            *ngIf="shouldShowQueryOption(field)"
                          >
                            Query
                          </button>
                          <button 
                            type="button" 
                            (click)="editStudy()"
                            *ngIf="field.type !== 'instruction' && EditHide()"
                            [disabled]="isFieldDisabledUser() || isFieldReadOnly(field)"
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            (click)="openReviewModal($event)"
                            *ngIf="canSeeReviewOption()"
                            [disabled]="isFieldReadOnly(field)"
                          >
                            Review
                          </button>
                        </div>
                      </div>

                      <!-- Unlock Field Modal -->
                      <div class="modal-overlay" *ngIf="isUnlockModalOpen">
                        <div class="modal-content">
                          <button class="close-btn" (click)="cancelUnlock()">
                            ×
                          </button>
                          <h4>Unlock Field for Editing</h4>
                          <p>
                            Please provide a reason for unlocking this field:
                          </p>
                          <textarea
                            class="form-control"
                            [(ngModel)]="unlockReason"
                            rows="4"
                            placeholder="Enter reason for editing this field..."
                            required
                          ></textarea>
                          <div class="modal-footer">
                            <button
                              class="btn custom-button"
                              (click)="confirmUnlock()"
                              [disabled]="!unlockReason.trim()"
                            >
                              Unlock Field
                            </button>
                            <button
                              class="btn custom-button"
                              (click)="cancelUnlock()"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- PI Check Confirmation Modal -->
                      <div class="modal-overlay" *ngIf="showPiCheckModal" (click)="closePiSignatureDropdowns()">
                        <div class="modal-content pi-signature-modal" (click)="$event.stopPropagation()">
                          <button
                            type="button"
                            class="close-btn"
                            (click)="cancelPiCheckChange()"
                            [disabled]="piCheckVerifying"
                          >
                            ×
                          </button>
                          <h4>PI Signature</h4>
                          <!-- STEP 1: Confirmation -->
                          <ng-container *ngIf="piSignatureStep === 1">
                            <div class="alert alert-warning">
                              <h6 class="mb-2" style="font-size: 0.95rem; line-height: 1.7;"><strong>Terms and Conditions</strong></h6>
                              <div class="mb-2" style="font-size: 0.95rem; line-height: 1.7;"><strong>Important Warnings:</strong></div>
                              <ul class="mb-3" style="font-size: 0.95rem; line-height: 1.7;">
                                <li>
                                  By proceeding, you apply an <strong>electronic signature</strong> that is legally
                                  equivalent to your handwritten signature.
                                </li>
                                <li>
                                  Your login credentials are <strong>unique</strong> to you and must not be used by anyone else.
                                </li>
                                <li>
                                  This will mark the selected form(s) as <strong>Reviewed by PI</strong> in Neptune EDC.
                                </li>
                              </ul>

                              <div style="font-size: 0.95rem; line-height: 1.7;">
                                I confirm that all data entered in the Neptune EDC
                                are complete and accurate. By using my account
                                name and password, I apply an electronic signature
                                that is legally equivalent to my handwritten
                                signature. I understand that my login credentials
                                are unique to me and may not be used by anyone
                                else.
                              </div>

                              <div class="form-check mt-3">
                                <input
                                  type="checkbox"
                                  class="form-check-input"
                                  id="piConfirmationAccepted"
                                  [checked]="piCheckConfirmationAccepted"
                                  (change)="onConfirmationCheckboxChange($event)"
                                  [disabled]="piCheckVerifying"
                                />
                                <label class="form-check-label" for="piConfirmationAccepted">
                                  I understand and accept the above terms and conditions
                                </label>
                              </div>
                            </div>

                            <div class="d-flex justify-content-end mt-3">
                              <button
                                type="button"
                                class="btn custom-button me-2"
                                (click)="cancelPiCheckChange()"
                                [disabled]="piCheckVerifying"
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                class="btn custom-button"
                                (click)="piSignatureStep = 2"
                                [disabled]="piCheckVerifying || !piCheckConfirmationAccepted"
                              >
                                Next
                              </button>
                            </div>
                          </ng-container>

                          <!-- STEP 2: Folder/Form selection style -->
                          <ng-container *ngIf="piSignatureStep === 2">
                            <div class="mb-3">
                              <label class="form-label" style="font-size: 0.95rem;">Folder</label>
                              <div class="custom-dropdown-instruction">
                                <i class="bx bx-info-circle"></i>
                                <strong>Tip:</strong> Use the checkboxes to select multiple folders for PI signature.
                              </div>
                              <div class="custom-dropdown-container">
                                <div
                                  class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
                                  (click)="togglePiSignatureFolderDropdown()"
                                >
                                  <span style="font-size: 0.95rem;">{{ getPiSignatureFolderLabel() }}</span>
                                  <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="custom-dropdown-list" *ngIf="showPiSignatureFolderDropdown">
                                  <div
                                    *ngFor="let folder of piSignatureAvailableFolders"
                                    class="custom-dropdown-item d-flex align-items-center"
                                  >
                                    <input
                                      type="checkbox"
                                      class="form-check-input me-2"
                                      [checked]="piSignatureFolderCheckboxes[folder.id] || false"
                                      (change)="togglePiSignatureFolderCheckbox(folder.id)"
                                      (click)="$event.stopPropagation()"
                                    />
                                    <span (click)="selectPiSignatureFolder(folder.id)" style="font-size: 0.95rem;">{{ folder.name }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="mb-3" *ngIf="(piSignatureFolderId && !hasAnyPiSignatureFolderCheckboxChecked()) || hasAnyPiSignatureFolderCheckboxChecked()">
                              <label class="form-label" style="font-size: 0.95rem;">Form</label>
                              <div class="custom-dropdown-instruction">
                                <i class="bx bx-info-circle"></i>
                                <strong>Tip:</strong> Use the checkboxes to select multiple forms for PI signature.
                              </div>
                              <div class="custom-dropdown-container">
                                <div
                                  class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
                                  (click)="togglePiSignatureFormDropdown()"
                                >
                                  <span style="font-size: 0.95rem;">{{ getPiSignatureFormLabel() }}</span>
                                  <i class="bx bx-chevron-down"></i>
                                </div>
                                <div class="custom-dropdown-list" *ngIf="showPiSignatureFormDropdown">
                                  <div
                                    *ngFor="let form of piSignatureAvailableForms"
                                    class="custom-dropdown-item d-flex align-items-center"
                                  >
                                    <input
                                      type="checkbox"
                                      class="form-check-input me-2"
                                      [checked]="piSignatureFormCheckboxes[form.id] || false"
                                      (change)="togglePiSignatureFormCheckbox(form.id)"
                                      (click)="$event.stopPropagation()"
                                    />
                                    <span (click)="selectPiSignatureForm(form.id)" style="font-size: 0.95rem;">{{ form.name }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn custom-button me-2"
                                (click)="piSignatureStep = 1"
                                [disabled]="piCheckVerifying"
                              >
                                Back
                              </button>
                              <button
                                type="button"
                                class="btn custom-button"
                                (click)="piSignatureStep = 3"
                                [disabled]="piCheckVerifying || (!piSignatureFolderId && !hasAnyPiSignatureFolderCheckboxChecked())"
                              >
                                Next
                              </button>
                            </div>
                          </ng-container>

                          <!-- STEP 3: Credentials and reason -->
                          <ng-container *ngIf="piSignatureStep === 3">
                            <div class="mb-3">
                              <label for="piCheckEmail" class="form-label"
                                >Email</label
                              >
                              <input
                                type="email"
                                class="form-control"
                                id="piCheckEmail"
                                [value]="piCheckEmail"
                                readonly
                                style="
                                  background-color: #e9ecef;
                                  cursor: not-allowed;
                                "
                              />
                            </div>
                            <div class="mb-3">
                              <label
                                for="piCheckPassword"
                                class="form-label"
                                >Password</label
                              >
                              <input
                                type="password"
                                class="form-control"
                                id="piCheckPassword"
                                [value]="piCheckPassword"
                                placeholder="Enter your password"
                                [disabled]="piCheckVerifying"
                                (input)="onPasswordInput($event)"
                                (keyup.enter)="confirmPiCheckChange()"
                              />
                            </div>
                            <div class="mb-3">
                              <label for="piCheckComment" class="form-label"
                                >Reason</label
                              >
                              <textarea
                                class="form-control"
                                id="piCheckComment"
                                rows="3"
                                [value]="piCheckComment"
                                placeholder="Enter reason for PI signature..."
                                [disabled]="piCheckVerifying"
                                (input)="onCommentInput($event)"
                              ></textarea>
                            </div>
                            <div
                              *ngIf="piCheckError"
                              class="alert alert-danger mb-3"
                              role="alert"
                            >
                              {{ piCheckError }}
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn custom-button me-2"
                                (click)="piSignatureStep = 2"
                                [disabled]="piCheckVerifying"
                              >
                                Back
                              </button>
                              <button
                                type="button"
                                class="btn custom-button"
                                (click)="confirmPiCheckChange()"
                                [disabled]="
                                  piCheckVerifying ||
                                  !isPasswordEntered() ||
                                  !piCheckComment ||
                                  !piCheckComment.trim()
                                "
                              >
                                <span *ngIf="piCheckVerifying"
                                  >Verifying...</span
                                >
                                <span *ngIf="!piCheckVerifying">Confirm</span>
                              </button>
                              <!-- <button
                                type="button"
                                class="btn custom-button"
                                (click)="cancelPiCheckChange()"
                                [disabled]="piCheckVerifying"
                              >
                                Cancel
                              </button> -->
                            </div>
                          </ng-container>
                        </div>
                      </div>

                      <!-- Review Modal -->
                      <div
                        class="modal-overlay1"
                        *ngIf="showReviewModal"
                        [style.top]="reviewModalPosition.top"
                        [style.right]="reviewModalPosition.right"
                        (click)="closeReviewModal()"
                      >
                        <!-- Close Button -->
                        <span class="close-button1" (click)="closeReviewModal()"
                          >×</span
                        >
                        <div
                          class="modal-content1"
                          (click)="$event.stopPropagation()"
                        >
                          <div class="checkbox-group" *ngIf="userRole !== 'Monitor'">
                            <div class="form-check" style="margin-top: 20px">
                              <input
                                type="checkbox"
                                id="reviewedByDataManager"
                                name="reviewedByDataManager"
                                [checked]="reviewOptions.dataManager"
                                [disabled]="!canToggleReviewCheckbox('dataManager')"
                                (click)="$event.stopPropagation()"
                                (change)="onReviewCheckboxToggle('dataManager', $event)"
                              />
                              <label for="reviewedByDataManager"
                                >Reviewed by Data Manager</label
                              >
                            </div>
                          </div>
                          <div class="checkbox-group" *ngIf="userRole !== 'Data Manager'">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                id="reviewedByMonitor"
                                name="reviewedByMonitor"
                                [checked]="reviewOptions.monitor"
                                [disabled]="!canToggleReviewCheckbox('monitor')"
                                (click)="$event.stopPropagation()"
                                (change)="onReviewCheckboxToggle('monitor', $event)"
                              />
                              <label for="reviewedByMonitor"
                                >Reviewed by {{ getReviewRoleLabel() }}</label
                              >
                            </div>
                          </div>
                          <!-- <div class="checkbox-group">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                id="reviewedByPI"
                                name="reviewedByPI"
                                [(ngModel)]="reviewOptions.pi"
                              />
                              <label for="reviewedByPI">Reviewed by PI</label>
                            </div>
                          </div> -->
                        </div>
                      </div>

                      <!-- Query and Field History Modal -->
                      <div class="modal-overlay query-modal-overlay" *ngIf="isModalOpen">
                        <div class="modal-content">
                          <button
                            type="button"
                            class="close-btn"
                            (click)="closeModal()"
                          >
                            &times;
                          </button>

                          <div class="tab-bar">
                            <div class="tab-wrapper">
                              <div
                                class="tab"
                                *ngFor="let tab of tabs; let idx = index"
                                [class.active]="selectedTab === idx"
                                (click)="selectTab(idx)"
                              >
                                {{ tab.title }}
                              </div>
                            </div>

                            <div
                              *ngIf="tabs[selectedTab].type === 'query' && userRole !== 'CRO'"
                              class="add-btn-wrapper"
                            >
                              <button
                                type="button"
                                class="add-btn"
                                [disabled]="isNewQueryDisabled"
                                [ngClass]="{
                                  'add-btn-disabled': isNewQueryDisabled,
                                }"
                                (click)="addQuery()"
                                [title]="
                                  isNewQueryDisabled
                                    ? 'Please submit the current new query before adding another.'
                                    : 'Add New Query'
                                "
                              >
                                New Query
                              </button>
                            </div>
                          </div>

                          <div class="modal-body">
                            <ng-container [ngSwitch]="tabs[selectedTab].type">
                              <div *ngSwitchCase="'query'">
                                <div
                                  *ngFor="let query of queries; let i = index"
                                  class="query-box"
                                  [class.query-box-closed]="query.isClosed"
                                >
                                  <div *ngIf="userRole !== 'CRO'">
                                    <div
                                      class="query-action-bar"
                                      *ngIf="!query.isClosed"
                                    >
                                      <div class="input-container">
                                        <input
                                          type="text"
                                          class="form-control"
                                          [value]="query.text"
                                          (input)="
                                            query.text = $event.target.value
                                          "
                                          [placeholder]="
                                            query.auditTrail?.length > 0
                                              ? 'Add responses'
                                              : 'Enter your query'
                                          "
                                        />
                                      </div>

                                      <div class="button-container">
                                        <button
                                          type="button"
                                          class="btn custom-button submit-btn"
                                          [disabled]="
                                            query.isClosed || !query.text?.trim()
                                          "
                                          (click)="
                                            confirmSubmitQuery(query, $event)
                                          "
                                        >
                                          Submit
                                        </button>

                                        <button
                                          type="button"
                                          class="btn custom-button close-btn-query"
                                          [disabled]="
                                            query.isClosed ||
                                            (!query.isSubmitted &&
                                              (!query.auditTrail || query.auditTrail.length === 0)) ||
                                            !canCloseQuery(query)
                                          "
                                          (click)="confirmCloseQuery(query)"
                                        >
                                          Close Query
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    class="audit-trail"
                                    [class.audit-trail-closed]="query.isClosed"
                                  >
                                    <h4>
                                      Audit Trail
                                      <span
                                        *ngIf="query.isClosed"
                                        class="closed-tag"
                                        >: Query is Closed</span
                                      >
                                    </h4>

                                    <!-- Debug: Show audit trail info -->
                                    <div *ngIf="!query.auditTrail || query.auditTrail.length === 0" class="text-muted small mb-2">
                                      No audit trail entries
                                    </div>

                                    <div
                                      class="audit-entry"
                                      *ngFor="let entry of query.auditTrail; trackBy: trackByAuditEntry"
                                    >
                                      <div class="user-avatar">
                                        {{ getUserInitials(entry.user || 'System') }}
                                      </div>

                                      <div class="message-content">
                                        <div class="user-info">
                                          <strong>{{ entry.user || 'System' }}</strong>
                                          <span class="timestamp">
                                            {{
                                              entry.timestamp
                                                | date: "dd-MMM-yyyy h:mm a"
                                            }}
                                          </span>
                                        </div>
                                        <div class="message-text">
                                          {{ entry.message }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div *ngSwitchCase="'fieldHistory'">
                                <div
                                  *ngIf="
                                    fieldHistoryData?.length > 0;
                                    else noData
                                  "
                                >
                                  <div
                                    *ngFor="
                                      let entry of fieldHistoryData
                                        .slice()
                                        .reverse()
                                    "
                                    class="history-box"
                                  >
                                    <div class="history-header">
                                      <strong>{{ entry.updated_by }}</strong> -
                                      {{ entry.updated_at | date: "medium" }}
                                    </div>
                                    <div
                                      class="history-value"
                                      *ngIf="!entry.isTable || !entry.tableData?.length"
                                    >
                                      {{ entry.value }}
                                    </div>
                                    <div
                                      class="history-table-wrapper"
                                      *ngIf="entry.isTable && entry.tableData?.length"
                                    >
                                      <table class="table table-bordered table-sm">
                                        <thead>
                                          <tr>
                                            <th>#</th>
                                            <th *ngFor="let column of entry.tableColumns">
                                              {{ column.title }}
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr *ngFor="let row of entry.tableData; let rowIndex = index">
                                            <td>{{ rowIndex + 1 }}</td>
                                            <td *ngFor="let column of entry.tableColumns">
                                              {{ formatHistoryCellValue(row[column.key]) }}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <div
                                      class="edit-reason"
                                      *ngIf="entry.edit_reason"
                                    >
                                      <em
                                        >Reason for change:
                                        {{ entry.edit_reason }}</em
                                      >
                                    </div>
                                  </div>
                                </div>
                                <ng-template #noData>
                                  <p>No history available for this field.</p>
                                </ng-template>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>

                      <!-- Review Info Popup Backdrop (for CRO/PI/CRC) -->
                      <div
                        class="modal-overlay"
                        *ngIf="showReviewInfoPopup"
                        (click)="closeReviewInfoPopup()"
                      ></div>
                      
                      <!-- Review Info Popup (for CRO/PI/CRC) -->
                      <div
                        class="modal-overlay1 modal-overlay-large"
                        *ngIf="showReviewInfoPopup"
                        (click)="$event.stopPropagation()"
                      >
                        <span class="close-button1" (click)="closeReviewInfoPopup()">×</span>
                        <div class="modal-content1">
                          <div class="review-info-title">Approval Details</div>
                          <div class="review-info-row">
                            <span class="value">
                              <span *ngIf="reviewInfo.dataManagerName !== 'Not done' && reviewInfo.dataManagerTime">
                                Reviewed by {{ reviewInfo.dataManagerName }}(Data Manager) on {{ reviewInfo.dataManagerTime | date: 'dd-MMM-yyyy h:mm a' }}
                              </span>
                              <span *ngIf="reviewInfo.dataManagerName === 'Not done' || !reviewInfo.dataManagerTime">Not done</span>
                            </span>
                          </div>
                          <div class="review-info-row">
                            <span class="value">
                              <span *ngIf="reviewInfo.monitorName !== 'Not done' && reviewInfo.monitorTime">
                                Reviewed by {{ reviewInfo.monitorName }}({{ getReviewRoleLabel() }}) on {{ reviewInfo.monitorTime | date: 'dd-MMM-yyyy h:mm a' }}
                              </span>
                              <span *ngIf="reviewInfo.monitorName === 'Not done' || !reviewInfo.monitorTime">Not done</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- Field Inputs -->
                      <input
                        *ngIf="field.type === 'text'"
                        type="text"
                        class="form-control"
                        [formControlName]="field.name"
                        [disabled]="isFieldDisabled(field)"
                      />
                      <input
                        *ngIf="field.type === 'date'"
                        type="date"
                        class="form-control"
                        [formControlName]="field.name"
                        (input)="validateDOBYear($event, field)"
                        (change)="validateDOBYear($event, field)"
                        (blur)="validateDOBYear($event, field)"
                        [max]="getMaxDateForField(field)"
                        [min]="getMinDate()"
                        [disabled]="isFieldDisabled(field)"
                      />
                      <input
                        *ngIf="field.type === 'time'"
                        type="time"
                        class="form-control"
                        [formControlName]="field.name"
                        [disabled]="isFieldDisabled(field)"
                      />
                      <input
                        *ngIf="field.type === 'number'"
                        type="text"
                        inputmode="text"
                        class="form-control"
                        [formControlName]="field.name"
                        [placeholder]="
                          field.unit
                            ? 'Enter value in ' + field.unit
                            : 'Enter number'
                        "
                        (input)="onNumberFieldInput(field, $event)"
                        [disabled]="isFieldDisabled(field)"
                      />
                      <!-- Auto-populated converted value (read-only) when conversion is configured -->
                      <div
                        *ngIf="field.conversionRequired"
                        class="calculated-field mt-2"
                      >
                        <label class="form-label mb-1">
                          Converted value
                          <span
                            *ngIf="field.conversionFromUnit && field.conversionToUnit"
                          >
                            ({{ field.conversionFromUnit }} →
                            {{ field.conversionToUnit }})
                          </span>
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          [formControlName]="field.name + '_converted'"
                          disabled
                          readonly
                          [placeholder]="'Converted value will populate here'"
                        />
                        <small class="form-text text-muted"
                          >This value is automatically converted</small
                        >
                      </div>
                      <textarea
                        *ngIf="field.type === 'textarea'"
                        class="form-control"
                        [formControlName]="field.name"
                        [disabled]="isFieldDisabled(field)"
                      ></textarea>

                      <!-- Calculated field type (read-only) -->
                      <!-- <input *ngIf="field.type === 'calculated'" 
                          type="text" 
                          class="form-control" 
                          [formControlName]="field.name" 
                          readonly 
                          [style.background-color]="'#f8f9fa'" /> -->

                      <select
                        *ngIf="
                          field.type === 'select' || field.type === 'dropdown'
                        "
                        class="form-control"
                        [formControlName]="field.name"
                        [disabled]="isFieldDisabled(field)"
                      >
                        <option value="">Select</option>
                        <option *ngFor="let opt of field.options" [value]="opt">
                          {{
                            field.valueToLabelMap
                              ? field.valueToLabelMap[opt]
                              : opt
                          }}
                        </option>
                      </select>

                      <div
                        *ngIf="field.type === 'radio'"
                        class="form-check-group"
                      >
                        <div
                          class="form-check"
                          *ngFor="let opt of field.options; let i = index"
                        >
                          <input
                            type="radio"
                            class="form-check-input"
                            [value]="opt"
                            [formControlName]="field.name"
                            [id]="field.name + '_' + opt"
                            [disabled]="isFieldDisabled(field)"
                          />
                          <label
                            class="form-check-label"
                            [for]="field.name + '_' + opt"
                          >
                            {{
                              field.valueToLabelMap
                                ? field.valueToLabelMap[opt]
                                : opt
                            }}
                          </label>
                        </div>
                      </div>

                      <div
                        *ngIf="field.type === 'checkbox'"
                        class="form-check-groupc"
                      >
                        <div
                          class="form-check"
                          *ngFor="let opt of field.options"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            [id]="field.name + '_' + opt"
                            [checked]="
                              ((form.controls[field.name] || form.get(field.name))?.value || []).includes(opt)
                            "
                            (change)="
                              toggleCheckbox(
                                field.name,
                                opt,
                                $event.target.checked
                              )
                            "
                            [disabled]="isFieldDisabled(field)"
                          />
                          <label
                            class="form-check-label"
                            [for]="field.name + '_' + opt"
                            >{{ opt }}</label
                          >
                        </div>
                      </div>

                      <!-- E-signature field type - just a text input for name -->
                      <input
                        *ngIf="
                          field.type === 'esignature' ||
                          field.type === 'signature'
                        "
                        type="text"
                        class="form-control"
                        [formControlName]="field.name"
                        placeholder="Enter signature name"
                        [disabled]="isFieldDisabled(field)"
                      />

                      <!-- Instruction field type - display only -->
                      <div
                        *ngIf="field.type === 'instruction' && logInstructionField(field)"
                        class="instruction-field-display"
                      >
                        <div *ngIf="field.instructionText">
                          <p style="white-space: pre-wrap; margin: 0; font-size: 14px; line-height: 1.6;">
                            {{ field.instructionText }}
                          </p>
                        </div>
                        <!-- Display instruction images -->
                        <div *ngIf="checkInstructionImages(field)" class="mt-3">
                          <div class="row">
                            <div
                              *ngFor="let image of field.instructionImages; let imgIndex = index"
                              class="col-md-4 col-sm-6 mb-3"
                            >
                              <div class="instruction-image-wrapper">
                                <!-- Try without crossorigin first, then with if it fails -->
                                <img
                                  [src]="getInstructionImageSrc(image)"
                                  [alt]="getInstructionImageAlt(image)"
                                  class="img-fluid rounded border"
                                  style="max-height: 200px; width: 100%; object-fit: contain; cursor: pointer;"
                                  (click)="openImageModal(getInstructionImageSrc(image))"
                                  loading="lazy"
                                  (error)="handleImageError($event, image)"
                                  (load)="handleImageLoad($event, image)"
                                />
                                <small *ngIf="hasImageName(image)" class="d-block mt-1 text-muted text-center">
                                  {{ getInstructionImageName(image) }}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Display instruction table -->
                        <div *ngIf="field.instructionColumns && field.instructionColumns.length > 0" class="mt-3">
                          <div class="table-wrapper">
                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Sr. No</th>
                                  <th
                                    *ngFor="
                                      let column of field.instructionColumns;
                                      let colIndex = index
                                    "
                                  >
                                    {{ column.title }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let row of getInstructionTableData(field); let rowIndex = index">
                                  <td class="text-center fw-bold">{{ rowIndex + 1 }}</td>
                                  <td
                                    *ngFor="
                                      let column of field.instructionColumns;
                                      let colIndex = index
                                    "
                                  >
                                    <!-- Display based on column type -->
                                    <span *ngIf="column.type === 'text'">{{ row[column.title] || '-' }}</span>
                                    <span *ngIf="column.type === 'number'">{{ row[column.title] || '-' }}</span>
                                    <span *ngIf="column.type === 'date'">{{ row[column.title] || '-' }}</span>
                                    <span *ngIf="column.type === 'textarea'">{{ row[column.title] || '-' }}</span>
                                    <span *ngIf="column.type === 'checkbox'">{{ row[column.title] ? 'Yes' : 'No' }}</span>
                                    <span *ngIf="column.type === 'dropdown'">{{ row[column.title] || '-' }}</span>
                                  </td>
                                </tr>
                                <tr *ngIf="!getInstructionTableData(field) || getInstructionTableData(field).length === 0">
                                  <td [attr.colspan]="field.instructionColumns.length + 1" class="text-center text-muted">
                                    No data available
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <!-- Compound field type -->
                      <div
                        *ngIf="field.type === 'compound'"
                        class="compound-field"
                      >
                        <div
                          *ngFor="let subField of field.subFields"
                          class="sub-field mb-2"
                        >
                          <label class="form-label">
                            {{ subField.title }}
                            >
                            <span
                              *ngIf="subField.required"
                              class="text-danger ms-1"
                              >*</span
                            >
                          </label>
                          <input
                            *ngIf="subField.type === 'number'"
                            type="text"
                            inputmode="text"
                            class="form-control"
                            [formControlName]="subField.name"
                            [placeholder]="
                              subField.unit
                                ? 'Enter value in ' + subField.unit
                                : 'Enter number'
                            "
                            [disabled]="isFieldDisabled(subField)"
                          />
                          <input
                            *ngIf="subField.type === 'text'"
                            type="text"
                            class="form-control"
                            [formControlName]="subField.name"
                            [disabled]="isFieldDisabled(subField)"
                          />
                        </div>
                      </div>

                      <!-- Calculated field type -->
                      <div
                        *ngIf="field.type === 'calculated'"
                        class="calculated-field"
                      >
                        <input
                          type="text"
                          class="form-control"
                          [formControlName]="field.name"
                          disabled
                          readonly
                          [placeholder]="'Calculated value will appear here'"
                        />
                        <small class="form-text text-muted"
                          >This field is automatically calculated</small
                        >
                      </div>

                      <!-- Table field type -->
                      <div *ngIf="field.type === 'table'" class="table-field">
                        <div
                          class="d-flex justify-content-between align-items-center mb-3"
                        >
                          <h6 class="table-head">{{ field.title }}</h6>
                          <div class="table-actions">
                            <button
                              type="button"
                              class="btn custom-button"
                              (click)="addTableRow(field.name)"
                              [disabled]="isFieldDisabledUser() || isFieldReadOnly(field)"
                            >
                              <i class="bx bx-plus"></i> Add Row
                            </button>
                          </div>
                        </div>

                        <div class="table-wrapper">
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th>Sr. No</th>
                                <th
                                  *ngFor="
                                    let column of field.columns;
                                    let colIndex = index
                                  "
                                >
                                  {{ column.title }}
                                  <span
                                    *ngIf="column.required"
                                    class="text-danger"
                                    >*</span
                                  >
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                *ngFor="
                                  let row of getTableData(field.name);
                                  let rowIndex = index
                                "
                                [ngClass]="{
                                  'query-open-row': hasOpenQueries(field.name, rowIndex),
                                  'query-closed-row': hasClosedQueries(field.name, rowIndex) && !hasOpenQueries(field.name, rowIndex)
                                }"
                              >
                                <td class="text-center fw-bold">
                                  {{ rowIndex + 1 }}
                                  <span
                                    class="query-status-icon-wrapper"
                                    *ngIf="
                                      hasOpenQueries(field.name, rowIndex) ||
                                      hasClosedQueries(field.name, rowIndex) ||
                                      hasAnsweredQueries(field.name, rowIndex)
                                    "
                                  >
                                    <i
                                      *ngIf="hasOpenQueries(field.name, rowIndex)"
                                      class="bx bxs-error-circle query-status-icon open"
                                      title="Open query"
                                    ></i>
                                    <i
                                      *ngIf="hasAnsweredQueries(field.name, rowIndex)"
                                      class="bx bxs-message-dots query-status-icon answered"
                                      title="Answered query"
                                    ></i>
                                    <i
                                      *ngIf="
                                        !hasOpenQueries(field.name, rowIndex) &&
                                        !hasAnsweredQueries(field.name, rowIndex) &&
                                        hasClosedQueries(field.name, rowIndex)
                                      "
                                      class="bx bxs-check-shield query-status-icon closed"
                                      title="Closed query"
                                    ></i>
                                  </span>
                                </td>

                                <td
                                  *ngFor="
                                    let column of field.columns;
                                    let colIndex = index
                                  "
                                >
                                  <!-- text -->
                                  <input
                                    *ngIf="column.type === 'text'"
                                    type="text"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isFieldReadOnly(field) ||
                                      isTableDisabled ||
                                      isTableRowLocked(field, rowIndex)
                                    "
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                  />

                                  <!-- date -->
                                  <input
                                    *ngIf="column.type === 'date'"
                                    type="date"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isFieldReadOnly(field) ||
                                      isTableDisabled ||
                                      isTableRowLocked(field, rowIndex)
                                    "
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [max]="getMaxDate()"
                                  />

                                  <!-- number -->
                                  <input
                                    *ngIf="column.type === 'number'"
                                    type="text"
                                    inputmode="text"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isFieldReadOnly(field) ||
                                      isTableDisabled ||
                                      isTableRowLocked(field, rowIndex)
                                    "
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                  />

                                  <!-- textarea -->
                                  <textarea
                                    *ngIf="column.type === 'textarea'"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isFieldReadOnly(field) ||
                                      isTableDisabled ||
                                      isTableRowLocked(field, rowIndex)
                                    "
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                  ></textarea>

                                  <!-- dropdown -->
                                  <select
                                    *ngIf="column.type === 'dropdown'"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isFieldReadOnly(field) ||
                                      isTableDisabled ||
                                      isTableRowLocked(field, rowIndex)
                                    "
                                    [value]="
                                      getTableCellValue(field.name, rowIndex, column.name || 'col_' + colIndex)
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                  >
                                    <option [value]="''">
                                      Select {{ column.title.toLowerCase() }}
                                    </option>
                                    <option
                                      *ngFor="let opt of getDropdownOptions(column)"
                                      [value]="opt.value"
                                      [attr.selected]="(getTableCellValue(field.name, rowIndex, column.name || ('col_' + colIndex)) === opt.value) ? true : null"
                                    >
                                      {{ opt.label }}
                                    </option>
                                  </select>

                                  <!-- checkbox -->
                                  <input
                                    *ngIf="column.type === 'checkbox'"
                                    type="checkbox"
                                    class="form-check-input"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isTableDisabled ||
                                      isTableRowLocked(field, rowIndex)
                                    "
                                    [checked]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.checked
                                      )
                                    "
                                  />
                                </td>

                                <!-- Actions column: three-dots menu per row -->
                                <!-- Actions column: three-dots menu per row -->
                                <td>
                                  <div
                                    class="form-group-wrapper"
                                    style="
                                      display: inline-block;
                                      position: relative;
                                      border: none !important;
                                      box-shadow: none;
                                    "
                                  >
                                    <!-- Hidden label span (used for fieldLabel binding) -->
                                    <label style="display: none">
                                      <span>{{
                                        field.name + "__row__" + rowIndex
                                      }}</span>
                                    </label>

                                    <!-- Three-dots icon that triggers options -->
                                    <div
                                      class="menu-icon"
                                      (click)="
                                        openOptionsModal($event, $event.target, field, rowIndex)
                                      "
                                      style="
                                        cursor: pointer;
                                        display: inline-block;
                                        padding: 4px 8px;
                                        user-select: none;
                                      "
                                      title="Options"
                                    >
                                      ⋮
                                    </div>

                                    <!-- Options dropdown per row -->
                                    <div
                                      class="options-modal"
                                      *ngIf="
                                        isOptionsModalOpen &&
                                        selectedOptionsFieldId ===
                                          (field.id != null
                                            ? field.id.toString() + '__row__' + rowIndex
                                            : null)
                                      "
                                      (click)="$event.stopPropagation()"
                                      style="
                                        position: absolute;
                                        right: 0;
                                        top: 24px;
                                        z-index: 800;
                                        background: #fff;
                                        border: 1px solid #ddd;
                                        box-shadow: 0 6px 12px
                                          rgba(0, 0, 0, 0.12);
                                        border-radius: 6px;
                                        min-width: 130px;
                                      "
                                      [ngStyle]="optionsModalStyle"
                                    >
                                      <div
                                        class="modal-buttons"
                                        style="
                                          display: flex;
                                          flex-direction: column;
                                          gap: 6px;
                                          padding: 8px;
                                        "
                                      >
                                        <!-- Query -->
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="openModal(field, rowIndex)"
                                          *ngIf="shouldShowQueryOption(field, rowIndex)"
                                          aria-label="Query"
                                          style="
                                            text-align: left;
                                            background: transparent;
                                            border: none;
                                            color: #441887;
                                            padding: 0 !important;
                                            font-size: 12px !important;
                                          "
                                        >
                                          Query
                                        </button>

                                        <!-- Edit -->
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="enableRowEdit(field.name, rowIndex)"
                                          *ngIf="EditHide()"
                                          [disabled]="isFieldDisabledUser() || isFieldReadOnly(field)"
                                          style="
                                            text-align: left;
                                            background: transparent;
                                            border: none;
                                            color: #441887;
                                            padding: 0 !important;
                                            font-size: 12px !important;
                                          "
                                        >
                                          Edit
                                        </button>

                                        <!-- Review -->
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="openReviewModal($event)"
                                          *ngIf="canSeeReviewOption()"
                                          style="
                                            text-align: left;
                                            background: transparent;
                                            border: none;
                                            color: #441887;
                                            padding: 0 !important;
                                            font-size: 12px !important;
                                          "
                                        >
                                          Review
                                        </button>

                                        <!-- Delete -->
                                        <button
                                          type="button"
                                          class="btn"
                                          (click)="
                                            removeTableRow(
                                              field.name,
                                              field.id,
                                              rowIndex
                                            )
                                          "
                                          [disabled]="isFieldDisabledUser() || isFieldReadOnly(field)"
                                          style="
                                            text-align: left;
                                            background: transparent;
                                            border: none;
                                            color: #441887;
                                            padding: 0 !important;
                                            font-size: 12px !important;
                                          "
                                        >
                                          Delete
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <!-- Empty state -->
                          <div
                            *ngIf="getTableData(field.name).length === 0"
                            class="text-center py-4"
                          >
                            <i class="bx bx-table display-4 text-muted"></i>
                            <p class="text-muted mt-2">
                              No data available.
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- Fixed Rows Table field type -->
                      <div *ngIf="field.type === 'fixed-rows-table'" class="table-field">
                        <div
                          class="d-flex justify-content-between align-items-center mb-3"
                        >
                          <h6 class="table-head">{{ field.title }}</h6>
                        </div>

                        <div class="table-wrapper">
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th *ngIf="getSrNoColumn(field)">{{ getSrNoColumn(field).title || 'Sr. No' }}</th>
                                <th
                                  *ngFor="
                                    let column of getTableColumnsExcludingSrNo(field);
                                    let colIndex = index
                                  "
                                >
                                  {{ column.title }}
                                  <span
                                    *ngIf="column.required"
                                    class="text-danger"
                                    >*</span
                                  >
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                *ngFor="
                                  let row of getTableData(field.name);
                                  let rowIndex = index
                                "
                                [ngClass]="{
                                  'query-open-row': hasOpenQueries(field.name, rowIndex),
                                  'query-closed-row': hasClosedQueries(field.name, rowIndex) && !hasOpenQueries(field.name, rowIndex)
                                }"
                              >
                                <td *ngIf="getSrNoColumn(field)" class="text-center fw-bold">
                                  {{ rowIndex + 1 }}
                                  <span
                                    class="query-status-icon-wrapper"
                                    *ngIf="
                                      hasOpenQueries(field.name, rowIndex) ||
                                      hasClosedQueries(field.name, rowIndex) ||
                                      hasAnsweredQueries(field.name, rowIndex)
                                    "
                                  >
                                    <i
                                      *ngIf="hasOpenQueries(field.name, rowIndex)"
                                      class="bx bxs-error-circle query-status-icon open"
                                      title="Open query"
                                    ></i>
                                    <i
                                      *ngIf="hasAnsweredQueries(field.name, rowIndex)"
                                      class="bx bxs-message-dots query-status-icon answered"
                                      title="Answered query"
                                    ></i>
                                    <i
                                      *ngIf="
                                        !hasOpenQueries(field.name, rowIndex) &&
                                        !hasAnsweredQueries(field.name, rowIndex) &&
                                        hasClosedQueries(field.name, rowIndex)
                                      "
                                      class="bx bxs-check-shield query-status-icon closed"
                                      title="Closed query"
                                    ></i>
                                  </span>
                                </td>

                                <td
                                  *ngFor="
                                    let column of getTableColumnsExcludingSrNo(field);
                                    let colIndex = index
                                  "
                                >
                                  <!-- Statement type - displays like Sr. No -->
                                  <div
                                    *ngIf="column.type === 'statement'"
                                    class="text-center fw-bold"
                                    [style.padding]="'0.375rem 0.75rem'"
                                    [style.min-height]="'38px'"
                                    [style.display]="'flex'"
                                    [style.align-items]="'center'"
                                    [style.justify-content]="'center'"
                                  >
                                    {{
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      ) || '-'
                                    }}
                                  </div>
                                  <!-- text -->
                                  <input
                                    *ngIf="column.type === 'text'"
                                    type="text"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isTableDisabled ||
                                      isFixedRowsRowLocked(field, rowIndex) ||
                                      (field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0))
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  />

                                  <!-- date -->
                                  <input
                                    *ngIf="column.type === 'date'"
                                    type="date"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isTableDisabled ||
                                      isFixedRowsRowLocked(field, rowIndex) ||
                                      (field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0))
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [max]="getMaxDate()"
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  />

                                  <!-- number -->
                                  <input
                                    *ngIf="column.type === 'number'"
                                    type="text"
                                    inputmode="text"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isTableDisabled ||
                                      isFixedRowsRowLocked(field, rowIndex) ||
                                      (field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0))
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  />

                                  <!-- textarea -->
                                  <textarea
                                    *ngIf="column.type === 'textarea'"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isTableDisabled ||
                                      isFixedRowsRowLocked(field, rowIndex) ||
                                      (field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0))
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  ></textarea>

                                  <!-- dropdown -->
                                  <select
                                    *ngIf="column.type === 'dropdown'"
                                    class="form-control"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isTableDisabled ||
                                      isFixedRowsRowLocked(field, rowIndex) ||
                                      (field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0))
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [value]="
                                      getTableCellValue(field.name, rowIndex, column.name || 'col_' + colIndex)
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  >
                                    <option value="">
                                      Select {{ column.title.toLowerCase() }}
                                    </option>
                                    <option
                                      *ngFor="let opt of getDropdownOptions(column)"
                                      [value]="opt.value"
                                      [attr.selected]="(getTableCellValue(field.name, rowIndex, column.name || ('col_' + colIndex)) === opt.value) ? true : null"
                                    >
                                      {{ opt.label }}
                                    </option>
                                  </select>

                                  <!-- checkbox -->
                                  <input
                                    *ngIf="column.type === 'checkbox'"
                                    type="checkbox"
                                    class="form-check-input"
                                    [disabled]="
                                      isFieldDisabledUser() ||
                                      isTableDisabled ||
                                      isFixedRowsRowLocked(field, rowIndex) ||
                                      (field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0))
                                    "
                                    [checked]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.checked
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <div
                                    class="menu-icon"
                                    (click)="openOptionsModal($event, $event.target, field, rowIndex)"
                                    title="Options"
                                  >
                                    ⋮
                                  </div>
                                  <div
                                    class="options-modal"
                                    *ngIf="
                                      isOptionsModalOpen &&
                                      selectedOptionsFieldId ===
                                        (field.id != null
                                          ? field.id.toString() + '__row__' + rowIndex
                                          : null)
                                    "
                                    (click)="$event.stopPropagation()"
                                    [ngStyle]="optionsModalStyle"
                                  >
                                    <div class="modal-buttons">
                                      <button
                                        type="button"
                                        (click)="openModal(field, rowIndex)"
                                        *ngIf="shouldShowQueryOption(field, rowIndex)"
                                      >
                                        Query
                                      </button>
                                      <button
                                        type="button"
                                        (click)="enableRowEdit(field.name, rowIndex)"
                                        *ngIf="EditHide()"
                                        [disabled]="isFieldDisabledUser()"
                                      >
                                        Edit
                                      </button>
                                      <button
                                        type="button"
                                        (click)="openReviewModal($event)"
                                        *ngIf="canSeeReviewOption()"
                                      >
                                        Review
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- Empty state -->
                          <div
                            *ngIf="getTableData(field.name).length === 0"
                            class="text-center py-4"
                          >
                            <i class="bx bx-table display-4 text-muted"></i>
                            <p class="text-muted mt-2">
                              No data available.
                            </p>
                          </div>
                        </div>
                      </div>

                      <!-- Conditional Navigation Buttons -->
                      <div
                        class="mt-3"
                        *ngIf="
                          field.type === 'radio' || field.type === 'dropdown'
                        "
                      >
                        <!-- Adverse Events Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'adverse-events')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            (click)="navigateToAdverseEvents()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Adverse Events
                            Data
                          </button>
                        </div>

                        <!-- Laboratory Investigation Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'laboratory')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToLaboratory()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Laboratory Data
                          </button>
                        </div>

                        <!-- Physical Examination Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'physical')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToPhysicalSystemic()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Physical
                            Examination Data
                          </button>
                        </div>

                        <!-- IDRS Assessment Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'idrs')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary btn-sm"
                            (click)="navigateToIDRS()"
                          >
                            <i class="bx bx-plus me-1"></i>Add IDRS Assessment
                            Data
                          </button>
                        </div>

                        <!-- Prior Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-dark btn-sm"
                            (click)="navigateToPriorMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Prior Medication
                            Data
                          </button>
                        </div>

                        <!-- Concomitant Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            (click)="navigateToConcomitantMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Concomitant
                            Medication Data
                          </button>
                        </div>

                        <!-- Rescue Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-warning btn-sm"
                            (click)="navigateToRescueMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Rescue Medication
                            Data
                          </button>
                        </div>

                        <!-- Medical History Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('medical history') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-info btn-sm"
                            (click)="navigateToMedicalHistory()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Medical History
                            Data
                          </button>
                        </div>

                        <!-- Baseline Physical Exam Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('physical') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToBaselinePhysicalExam()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Baseline Physical
                            Exam Data
                          </button>
                        </div>

                        <!-- Baseline Lab Investigation Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('laboratory') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToBaselineLabInvestigation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Baseline
                            Laboratory Data
                          </button>
                        </div>

                        <!-- Follow-up Physical Exam Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('physical') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToFollowUpPhysical()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Follow-up
                            Physical Exam Data
                          </button>
                        </div>

                        <!-- Follow-up Lab Investigation Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('laboratory') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToFollowUpLabInvestigation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Follow-up
                            Laboratory Data
                          </button>
                        </div>

                        <!-- Medicine Dispensing Vital Signs Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('medicine') &&
                            field.title.toLowerCase().includes('vital signs') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-success btn-sm"
                            (click)="navigateToMedicineVitalSigns()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Medicine
                            Dispensing Vital Signs Data
                          </button>
                        </div>
                        <!-- Adverse Events Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('adverse event') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            (click)="navigateToAdverseEvents()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Adverse Events
                            Data
                          </button>
                        </div>
                        <!-- Concomitant Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToConcomitantMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Concomitant
                            Medication Data
                          </button>
                        </div>
                        <!-- Rescue Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-warning btn-sm"
                            (click)="navigateToRescueMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Rescue Medication
                            Data
                          </button>
                        </div>
                        <!-- Prior Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-info btn-sm"
                            (click)="navigateToPriorMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Prior Medication
                            Data
                          </button>
                        </div>
                        <!-- Protocol Deviation Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('protocol deviation') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-danger btn-sm"
                            (click)="navigateToProtocolDeviation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Protocol
                            Deviation Data
                          </button>
                        </div>
                        <!-- Study Completion Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('study completion') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-success btn-sm"
                            (click)="navigateToStudyCompletion()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Study Completion
                            Data
                          </button>
                        </div>
                      </div>

                      <!-- Conditional Comment Fields for "No" answers -->
                      <div
                        class="mt-3"
                        *ngIf="
                          field.type === 'radio' &&
                          getFieldValue(field.name) === 'no'
                        "
                      >
                        <!-- Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[field.name + '_vitalSignsComments']
                            "
                            name="vitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Physical Examination Comments -->
                        <div
                          *ngIf="field.title.toLowerCase().includes('physical')"
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_physicalExamComments'
                              ]
                            "
                            name="physicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing physical examination..."
                          >
                          </textarea>
                        </div>
                        <!-- IDRS Assessment Comments -->
                        <div
                          *ngIf="field.title.toLowerCase().includes('idrs')"
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_idrsAssessmentComments'
                              ]
                            "
                            name="idrsAssessmentComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing IDRS assessment..."
                          >
                          </textarea>
                        </div>
                        <!-- Laboratory Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_labInvestigationComments'
                              ]
                            "
                            name="labInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing laboratory investigation..."
                          >
                          </textarea>
                        </div>

                        <!-- Baseline Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselineVitalSignsComments'
                              ]
                            "
                            name="baselineVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline vital signs evaluation..."
                          >
                          </textarea>
                        </div>

                        <!-- Baseline Physical Exam Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('physical')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselinePhysicalExamComments'
                              ]
                            "
                            name="baselinePhysicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline physical examination..."
                          >
                          </textarea>
                        </div>

                        <!-- Baseline Lab Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselineLabInvestigationComments'
                              ]
                            "
                            name="baselineLabInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline laboratory investigation..."
                          >
                          </textarea>
                        </div>

                        <!-- Follow-up Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpVitalSignsComments'
                              ]
                            "
                            name="followUpVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up vital signs evaluation..."
                          >
                          </textarea>
                        </div>

                        <!-- Follow-up Physical Exam Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('physical')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpPhysicalExamComments'
                              ]
                            "
                            name="followUpPhysicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up physical examination..."
                          >
                          </textarea>
                        </div>

                        <!-- Follow-up Lab Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpLabInvestigationComments'
                              ]
                            "
                            name="followUpLabInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up laboratory investigation..."
                          >
                          </textarea>
                        </div>

                        <!-- Medicine Dispensing Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('medicine') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_medicineVitalSignsComments'
                              ]
                            "
                            name="medicineVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing medicine dispensing vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Adverse Events Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('adverse event')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_adverseEventsComments'
                              ]
                            "
                            name="adverseEventsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording adverse events..."
                          >
                          </textarea>
                        </div>
                        <!-- Concomitant Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_concomitantMedicationComments'
                              ]
                            "
                            name="concomitantMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording concomitant medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Rescue Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_rescueMedicationComments'
                              ]
                            "
                            name="rescueMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording rescue medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Prior Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_priorMedicationComments'
                              ]
                            "
                            name="priorMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording prior medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Protocol Deviation Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('protocol deviation')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_protocolDeviationComments'
                              ]
                            "
                            name="protocolDeviationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording protocol deviation..."
                          >
                          </textarea>
                        </div>
                        <!-- Study Completion Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('study completion')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_studyCompletionComments'
                              ]
                            "
                            name="studyCompletionComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not completing study..."
                          >
                          </textarea>
                        </div>
                      </div>

                      <!-- Attachment section shown when enabled for the field -->
                      <div
                        *ngIf="field.attachmentRequired == 1 ? true : false"
                        class="attachment-section mt-3"
                      >
                        <label class="form-label">
                          <i class="fa fa-paperclip"></i> Attachments
                          <span *ngIf="field.required" class="text-danger"
                            >*</span
                          >
                        </label>

                        <div
                          *ngIf="existingAttachments[field.name]?.length"
                          class="existing-files mt-2"
                        >
                          <div class="fw-semibold small mb-1">
                            Existing attachments ({{ existingAttachments[field.name].length }})
                          </div>
                          <div
                            class="d-flex align-items-center flex-nowrap mb-2"
                            style="overflow-x: auto; gap: 6px; padding-bottom: 2px;"
                          >
                            <div
                              *ngFor="
                                let attachment of existingAttachments[field.name]
                              "
                              class="badge rounded-pill bg-light d-inline-flex align-items-center px-2 py-1"
                              style="font-size: 11px; white-space: nowrap; min-width: 150px; max-width: 240px; border: 1px solid #ced4da;"
                              [title]="attachment.name"
                            >
                              <i
                                [class]="getFileIcon(attachment.name)"
                                class="me-1"
                              ></i>
                              <span class="text-truncate me-2">
                                {{ attachment.name }}
                              </span>
                              <button
                                type="button"
                                class="btn btn-link btn-xs p-0 ms-1"
                                (click)="openExistingAttachment(field.name, attachment)"
                                title="Open"
                              >
                                <i class="fa fa-eye"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-link btn-xs p-0 ms-1"
                                (click)="downloadExistingAttachment(field.name, attachment)"
                                title="Download"
                              >
                                <i class="fa fa-download"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="file-input-wrapper">
                          <input
                            type="file"
                            class="form-control"
                            [id]="field.name + '_file'"
                            multiple
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif"
                            (change)="onFileSelected($event, field.name)"
                            [formControlName]="field.name + '_attachments'"
                          />
                          <small class="form-text text-muted">
                            Supported: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG, GIF. You can attach up to 5 files for this field.
                          </small>
                        </div>

                        <div
                          *ngIf="selectedFiles[field.name]?.length"
                          class="selected-files mt-2"
                        >
                          <div
                            *ngFor="
                              let file of selectedFiles[field.name];
                              let fileIndex = index
                            "
                            class="selected-file-item d-flex align-items-center justify-content-between p-2 border rounded mb-2"
                          >
                            <div class="d-flex align-items-center">
                              <i
                                [class]="getFileIcon(file.name)"
                                class="me-2"
                              ></i>
                              <span class="file-name">{{ file.name }}</span>
                              <small class="text-muted ms-2"
                                >({{
                                  (file.size / 1024 / 1024).toFixed(2)
                                }}
                                MB)</small
                              >
                            </div>
                            <div class="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="openFile(file)"
                                title="Open file"
                              >
                                <i class="fa fa-eye"></i> Open file
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-success"
                                (click)="downloadFile(file)"
                                title="Download file"
                              >
                                <i class="fa fa-download"></i> Download file
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                (click)="removeFile(field.name, fileIndex)"
                                title="Remove file"
                              >
                                <i class="fa fa-times"></i> Remove file
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Dependent Fields Section - Fields that depend on this field -->
                      <div
                        class="dependent-fields-section mt-3"
                        *ngIf="getDependentFields(field).length > 0"
                      ></div>

                      <!-- SubHeader - Display at the end of every field except instruction type -->
                      <div
                        *ngIf="field.subHeader && field.type !== 'instruction'"
                        class="sub-header mt-2"
                        style="font-size: 14px; color: #6c757d; font-style: italic;"
                      >
                        <strong>Note:</strong> {{ field.subHeader }}
                      </div>
                    </div>
                  </ng-container>
                </div>

                <!-- Empty state for fields -->
                <div class="text-center py-4" *ngIf="fields.length === 0">
                  <i class="bx bx-file display-6 text-muted"></i>
                  <div class="text-muted">
                    No fields yet. Click "Create Field" to add fields.
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between align-items-center mt-3"
                  *ngIf="fields.length > 0 && SignatureCheck()"
                >
                  <div class="pi-signature-section w-100">
                    <div
                      class="pi-confirmation-text mt-2"
                      *ngIf="getPiSignatureReviewed()"
                      style="
                        font-size: 0.95rem;
                        line-height: 1.7;
                        color: #495057;
                        padding-left: 0.25rem;
                        font-style: italic;
                      "
                    >
                      I confirm that all data entered in the Neptune EDC
                      are complete and accurate. By using my account
                      name and password, I apply an electronic signature
                      that is legally equivalent to my handwritten
                      signature. I understand that my login credentials
                      are unique to me and may not be used by anyone
                      else.
                    </div>
                    <div
                      class="pi-validation-text mt-1"
                      *ngIf="getPiValidationText()"
                      style="
                        font-size: 0.875rem;
                        color: #6c757d;
                        padding-left: 0.25rem;
                      "
                    >
                      <div>{{ getPiValidationText() }}</div>
                    </div>
                    <div
                      *ngIf="
                        getPiSignatureReviewed() &&
                        getPiComment() &&
                        getPiComment()!.trim()
                      "
                      class="pi-comment-text mt-1"
                      style="
                        font-size: 0.875rem;
                        font-style: italic;
                        color: #495057;
                        padding-left: 0.25rem;
                      "
                    >
                      Comment: {{ getPiComment() }}
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!-- Review Modal - Outside Form -->
            <div
              class="modal-overlay1"
              *ngIf="showReviewModal"
              [style.top]="reviewModalPosition.top"
              [style.right]="reviewModalPosition.right"
              (click)="closeReviewModal()"
            >
              <!-- Close Button -->
              <span class="close-button1" (click)="closeReviewModal()"
                >×</span
              >
              <div
                class="modal-content1"
                (click)="$event.stopPropagation()"
              >
                <div class="checkbox-group" *ngIf="userRole !== 'Monitor'">
                  <div class="form-check" style="margin-top: 20px">
                    <input
                      type="checkbox"
                      id="reviewedByDataManager"
                      name="reviewedByDataManager"
                      [checked]="reviewOptions.dataManager"
                      [disabled]="!canToggleReviewCheckbox('dataManager')"
                      (click)="$event.stopPropagation()"
                      (change)="onReviewCheckboxToggle('dataManager', $event)"
                    />
                    <label for="reviewedByDataManager"
                      >Reviewed by Data Manager</label
                    >
                  </div>
                </div>
                <div class="checkbox-group" *ngIf="userRole !== 'Data Manager'">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      id="reviewedByMonitor"
                      name="reviewedByMonitor"
                      [checked]="reviewOptions.monitor"
                      [disabled]="!canToggleReviewCheckbox('monitor')"
                      (click)="$event.stopPropagation()"
                      (change)="onReviewCheckboxToggle('monitor', $event)"
                    />
                    <label for="reviewedByMonitor"
                      >Reviewed by {{ getReviewRoleLabel() }}</label
                    >
                  </div>
                </div>
                <!-- <div class="checkbox-group">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      id="reviewedByPI"
                      name="reviewedByPI"
                      [(ngModel)]="reviewOptions.pi"
                    />
                    <label for="reviewedByPI">Reviewed by PI</label>
                  </div>
                </div> -->
              </div>
            </div>

            <!-- Submit Button - Fixed at bottom -->
            <div class="card-footer">
              <button
                class="btn custom-button"
                type="button"
                *ngIf="EditHide()" 
                (click)="onSubmit()"
              >
                Submit
              </button>
            </div>
          </div>

          <!-- Statement Input Modal for Fixed Rows Table -->
          <div class="modal-overlay" *ngIf="isStatementModalOpen">
            <div class="modal-content">
              <button
                type="button"
                class="close-btn"
                (click)="closeStatementModal()"
              >
                ×
              </button>
              <h4>Enter Statement Values</h4>
              <p class="text-muted mb-3">Please enter values for all statement columns:</p>
              <div class="statement-inputs">
                <div
                  *ngFor="let column of statementModalColumns"
                  class="mb-3"
                >
                  <label class="form-label">
                    {{ column.title }}
                    <span *ngIf="column.required" class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    [ngModel]="statementModalValues[getStatementColumnKey(column)]"
                    (ngModelChange)="statementModalValues[getStatementColumnKey(column)] = $event"
                    [placeholder]="'Enter ' + (column.title || 'value')"
                    [required]="column.required"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="submitStatementModal()"
                >
                  Add Row
                </button>
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="closeStatementModal()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

          <!-- Edit Reason Modal - Outside Form -->
          <div class="modal-overlay" *ngIf="isReasonModalOpen">
            <div class="modal-content">
              <button
                type="button"
                class="close-btn"
                (click)="cancelEditReason()"
              >
                ×
              </button>
              <h4>Please provide a reason for editing:</h4>
              <textarea
                class="form-control"
                [(ngModel)]="editReason"
                rows="4"
                placeholder="Enter reason here..."
              ></textarea>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="confirmEditReason()"
                >
                  Confirm
                </button>
                <button
                  type="button"
                  class="btn custom-button"
                  (click)="cancelEditReason()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

          <!-- No form selected state -->
          <div class="text-center py-5" *ngIf="!currentForm">
            <i class="bx bx-file display-1 text-muted"></i>
            <h5 class="mt-3">No Form Selected</h5>
            <p class="text-muted">
              Select a form from the sidebar to view and edit its fields.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Review Monitor/Data Manager Modal (authenticated review with login + folder/form/field selection) -->
<div
  class="modal"
  *ngIf="showMonitorReviewModal"
  (click)="closeMonitorReviewDropdowns()"
>
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">Review by {{ getReviewRoleLabel() }}</h5>

      <!-- STEP 1: Confirmation -->
      <ng-container *ngIf="monitorReviewStep === 1">
        <div class="alert alert-warning">
          <h6 class="mb-2"><strong>Terms and Conditions</strong></h6>
          <p class="mb-2" style="font-size: 0.95rem; line-height: 1.7;">
            I confirm that I have reviewed the selected folder/form/field data
            in the Neptune EDC. By using my account name and password, I apply
            an electronic confirmation that is legally equivalent to my
            handwritten sign-off. I understand that my login credentials are
            unique to me and may not be used by anyone else.
          </p>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="monitorReviewTermsAccepted"
              [(ngModel)]="monitorReviewConfirmationAccepted"
              [disabled]="monitorReviewVerifying"
            />
            <label class="form-check-label" for="monitorReviewTermsAccepted">
              I understand and accept the above terms and conditions
            </label>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="closeMonitorReviewModal()" [disabled]="monitorReviewVerifying">
            Cancel
          </button>
          <button
            class="btn custom-button"
            (click)="goToMonitorReviewStep2()"
            [disabled]="monitorReviewVerifying || !monitorReviewConfirmationAccepted"
          >
            Next
          </button>
        </div>
      </ng-container>

      <!-- STEP 2: Target selection -->
      <ng-container *ngIf="monitorReviewStep === 2">
        <div class="mb-3">
          <label class="form-label">Folder:</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple folders for review.
          </div>
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleMonitorReviewFolderDropdown()"
            >
              <span>{{ getMonitorReviewFolderLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showMonitorReviewFolderDropdown">
              <div
                *ngFor="let folder of monitorReviewAvailableFolders"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="selectMonitorReviewFolder(folder.id)"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="monitorReviewFolderCheckboxes[folder.id] || false"
                  (click)="$event.stopPropagation()"
                  (change)="toggleMonitorReviewFolderCheckbox(folder.id)"
                />
                <span>{{ folder.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="monitorReviewFolderId || hasAnyMonitorReviewFolderCheckboxChecked()">
          <label class="form-label">Form (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple forms for review.
          </div>
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleMonitorReviewFormDropdown()"
            >
              <span>{{ getMonitorReviewFormLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showMonitorReviewFormDropdown">
              <div
                *ngFor="let form of monitorReviewAvailableForms"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="selectMonitorReviewForm(form.id)"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="monitorReviewFormCheckboxes[form.id] || false"
                  (click)="$event.stopPropagation()"
                  (change)="toggleMonitorReviewFormCheckbox(form.id)"
                />
                <span>{{ form.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="monitorReviewFormId || hasAnyMonitorReviewFormCheckboxChecked()">
          <label class="form-label">Field (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple fields for review.
          </div>
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleMonitorReviewFieldDropdown()"
            >
              <span>{{ getMonitorReviewFieldLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showMonitorReviewFieldDropdown">
              <div
                *ngFor="let fld of monitorReviewAvailableFields"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="selectMonitorReviewField(fld.id)"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="monitorReviewFieldCheckboxes[fld.id] || false"
                  (click)="$event.stopPropagation()"
                  (change)="toggleMonitorReviewFieldCheckbox(fld.id)"
                />
                <span>{{ fld.title }}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="monitorReviewError" class="text-danger mb-3">
          {{ monitorReviewError }}
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="backToMonitorReviewStep1()" [disabled]="monitorReviewVerifying">
            Back
          </button>
          <button
            class="btn custom-button"
            (click)="goToMonitorReviewStep3()"
            [disabled]="monitorReviewVerifying || (!monitorReviewFolderId && !hasAnyMonitorReviewFolderCheckboxChecked())"
          >
            Next
          </button>
        </div>
      </ng-container>

      <!-- STEP 3: Credentials and reason -->
      <ng-container *ngIf="monitorReviewStep === 3">
        <div class="mb-3">
          <label class="form-label">Email:</label>
          <input
            type="email"
            class="form-control"
            [value]="monitorReviewEmail"
            readonly
            style="background-color: #e9ecef; cursor: not-allowed;"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">Password:</label>
          <div class="input-group">
            <input
              [type]="showMonitorReviewPassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="monitorReviewPassword"
              placeholder="Enter your password"
              [disabled]="monitorReviewVerifying"
              (keyup.enter)="authenticateAndApplyMonitorReview()"
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="toggleMonitorReviewPasswordVisibility()"
              [disabled]="monitorReviewVerifying"
            >
              <i class="bx" [class.bx-show]="!showMonitorReviewPassword" [class.bx-hide]="showMonitorReviewPassword"></i>
            </button>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Reason:</label>
          <textarea
            class="form-control"
            [(ngModel)]="monitorReviewReason"
            rows="3"
            placeholder="Enter reason for monitor review..."
            [disabled]="monitorReviewVerifying"
          ></textarea>
        </div>
        <div *ngIf="monitorReviewError" class="text-danger mb-3">
          {{ monitorReviewError }}
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="backToMonitorReviewStep2()" [disabled]="monitorReviewVerifying">
            Back
          </button>
          <button
            class="btn custom-button"
            (click)="authenticateAndApplyMonitorReview()"
            [disabled]="monitorReviewVerifying || !monitorReviewPassword || !monitorReviewReason || !monitorReviewReason.trim()"
          >
            <span *ngIf="monitorReviewVerifying">Verifying...</span>
            <span *ngIf="!monitorReviewVerifying">Confirm</span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Review Data Manager Modal (Data Manager login + folder/form/field selection) -->
<div
  class="modal"
  *ngIf="showDataManagerReviewModal"
  (click)="closeDataManagerReviewDropdowns()"
>
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">Review</h5>

      <!-- STEP 1: Confirmation -->
      <ng-container *ngIf="dataManagerReviewStep === 1">
        <div class="alert alert-warning">
          <h6 class="mb-2"><strong>Terms and Conditions</strong></h6>
          <p class="mb-2" style="font-size: 0.95rem; line-height: 1.7;">
            I confirm that I have reviewed the selected folder/form/field data
            in the Neptune EDC. By using my account name and password, I apply
            an electronic confirmation that is legally equivalent to my
            handwritten sign-off. I understand that my login credentials are
            unique to me and may not be used by anyone else.
          </p>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="dataManagerReviewTermsAccepted"
              [(ngModel)]="dataManagerReviewConfirmationAccepted"
              [disabled]="dataManagerReviewVerifying"
            />
            <label class="form-check-label" for="dataManagerReviewTermsAccepted">
              I understand and accept the above terms and conditions
            </label>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="closeDataManagerReviewModal()" [disabled]="dataManagerReviewVerifying">
            Cancel
          </button>
          <button
            class="btn custom-button"
            (click)="goToDataManagerReviewStep2()"
            [disabled]="dataManagerReviewVerifying || !dataManagerReviewConfirmationAccepted"
          >
            Next
          </button>
        </div>
      </ng-container>

      <!-- STEP 2: Target selection -->
      <ng-container *ngIf="dataManagerReviewStep === 2">
        <div class="mb-3">
          <label class="form-label">Folder:</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple folders for review.
          </div>
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleDataManagerReviewFolderDropdown()"
            >
              <span>{{ getDataManagerReviewFolderLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showDataManagerReviewFolderDropdown">
              <div
                *ngFor="let folder of dataManagerReviewAvailableFolders"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="selectDataManagerReviewFolder(folder.id)"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="dataManagerReviewFolderCheckboxes[folder.id] || false"
                  (click)="$event.stopPropagation()"
                  (change)="toggleDataManagerReviewFolderCheckbox(folder.id)"
                />
                <span>{{ folder.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="dataManagerReviewFolderId || hasAnyDataManagerReviewFolderCheckboxChecked()">
          <label class="form-label">Form (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple forms for review.
          </div>
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleDataManagerReviewFormDropdown()"
            >
              <span>{{ getDataManagerReviewFormLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showDataManagerReviewFormDropdown">
              <div
                *ngFor="let form of dataManagerReviewAvailableForms"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="selectDataManagerReviewForm(form.id)"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="dataManagerReviewFormCheckboxes[form.id] || false"
                  (click)="$event.stopPropagation()"
                  (change)="toggleDataManagerReviewFormCheckbox(form.id)"
                />
                <span>{{ form.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="dataManagerReviewFormId || hasAnyDataManagerReviewFormCheckboxChecked()">
          <label class="form-label">Field (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple fields for review.
          </div>
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleDataManagerReviewFieldDropdown()"
            >
              <span>{{ getDataManagerReviewFieldLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showDataManagerReviewFieldDropdown">
              <div
                *ngFor="let fld of dataManagerReviewAvailableFields"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="selectDataManagerReviewField(fld.id)"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="dataManagerReviewFieldCheckboxes[fld.id] || false"
                  (click)="$event.stopPropagation()"
                  (change)="toggleDataManagerReviewFieldCheckbox(fld.id)"
                />
                <span>{{ fld.title }}</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="dataManagerReviewError" class="text-danger mb-3">
          {{ dataManagerReviewError }}
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="backToDataManagerReviewStep1()" [disabled]="dataManagerReviewVerifying">
            Back
          </button>
          <button
            class="btn custom-button"
            (click)="goToDataManagerReviewStep3()"
            [disabled]="dataManagerReviewVerifying || (!dataManagerReviewFolderId && !hasAnyDataManagerReviewFolderCheckboxChecked())"
          >
            Next
          </button>
        </div>
      </ng-container>

      <!-- STEP 3: Credentials and reason -->
      <ng-container *ngIf="dataManagerReviewStep === 3">
        <div class="mb-3">
          <label class="form-label">Email:</label>
          <input
            type="email"
            class="form-control"
            [value]="dataManagerReviewEmail"
            readonly
            style="background-color: #e9ecef; cursor: not-allowed;"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">Password:</label>
          <div class="input-group">
            <input
              [type]="showDataManagerReviewPassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="dataManagerReviewPassword"
              placeholder="Enter your password"
              [disabled]="dataManagerReviewVerifying"
              (keyup.enter)="authenticateAndApplyDataManagerReview()"
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="toggleDataManagerReviewPasswordVisibility()"
              [disabled]="dataManagerReviewVerifying"
            >
              <i class="bx" [class.bx-show]="!showDataManagerReviewPassword" [class.bx-hide]="showDataManagerReviewPassword"></i>
            </button>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Reason:</label>
          <textarea
            class="form-control"
            [(ngModel)]="dataManagerReviewReason"
            rows="3"
            placeholder="Enter reason for review..."
            [disabled]="dataManagerReviewVerifying"
          ></textarea>
        </div>
        <div *ngIf="dataManagerReviewError" class="text-danger mb-3">
          {{ dataManagerReviewError }}
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="backToDataManagerReviewStep2()" [disabled]="dataManagerReviewVerifying">
            Back
          </button>
          <button
            class="btn custom-button"
            (click)="authenticateAndApplyDataManagerReview()"
            [disabled]="dataManagerReviewVerifying || !dataManagerReviewPassword || !dataManagerReviewReason || !dataManagerReviewReason.trim()"
          >
            <span *ngIf="dataManagerReviewVerifying">Verifying...</span>
            <span *ngIf="!dataManagerReviewVerifying">Confirm</span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Freeze / Unfreeze Modal -->
<div
  class="modal"
  *ngIf="showFreezeModal"
  (click)="closeFreezeDropdowns()"
>
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">
        {{ isFreezing ? 'Freeze' : 'Unfreeze' }} Configuration
      </h5>

      <ng-container *ngIf="freezeStep === 1">
        <div class="alert alert-info" *ngIf="isFreezing">
          <small>
            Freezing will make the selected folder/form/field <strong>view-only</strong>.
            No structural changes will be allowed until it is unfreezed.
          </small>
        </div>
        <div class="alert alert-success" *ngIf="!isFreezing">
          <small>
            Unfreezing will restore editing capabilities for the selected
            folder/form/field.
          </small>
        </div>

        <div class="alert alert-warning">
          <h6 class="mb-2"><strong>Terms and Conditions</strong></h6>
          <div class="mb-2"><strong>Important Warnings:</strong></div>
          <ul class="mb-3">
            <li>When freezed, the selected item will be <strong>view-only</strong>.</li>
            <li>You will <strong>NOT</strong> be able to edit data, raise queries, or change the data until it is unfreezed.</li>
            <li>You can <strong>unfreeze</strong> later to restore editing.</li>
          </ul>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="freezeTermsAccepted"
              [(ngModel)]="freezeConfirmationAccepted"
            />
            <label class="form-check-label" for="freezeTermsAccepted">
              I understand and accept the above terms and conditions
            </label>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="closeFreezeModal()">
            Cancel
          </button>
          <button
            class="btn custom-button"
            (click)="goToFreezeStep2()"
            [disabled]="!freezeConfirmationAccepted"
          >
            Next
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="freezeStep === 2">
        <div class="mb-3">
          <label class="form-label">Selected Folder:</label>

          <!-- If opened from a folder's 3-dots menu, show folder name only (no picker) -->
          <ng-container *ngIf="freezeOpenedFromFolderMenu; else freezeFolderPicker">
            <input
              type="text"
              class="form-control"
              [value]="getFolderNameById(freezeFolderId)"
              readonly
            />
          </ng-container>

          <!-- Default flow: allow selecting folders (including multi-select) -->
          <ng-template #freezeFolderPicker>
            <div class="custom-dropdown-instruction">
              <i class="bx bx-info-circle"></i>
              <strong>Tip:</strong> Use the checkboxes to select multiple folders for {{ isFreezing ? 'freezing' : 'unfreezing' }}.
            </div>
            <div class="custom-dropdown-container">
              <div
                class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
                (click)="toggleFreezeFolderDropdown()"
              >
                <span>{{ getFreezeFolderLabel() }}</span>
                <i class="bx bx-chevron-down"></i>
              </div>
              <div class="custom-dropdown-list" *ngIf="showFreezeFolderDropdown">
                <div
                  *ngFor="let folder of freezeAvailableFolders"
                  class="custom-dropdown-item d-flex align-items-center"
                  (click)="selectFreezeFolder(folder.id)"
                >
                  <input
                    type="checkbox"
                    class="form-check-input me-2"
                    [checked]="freezeFolderCheckboxes[folder.id] || false"
                    (click)="$event.stopPropagation()"
                    (change)="toggleFreezeFolderCheckbox(folder.id)"
                  />
                  <span>{{ folder.name }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="mb-3" *ngIf="(freezeFolderId && !hasAnyFreezeFolderCheckboxChecked())">
          <label class="form-label">Select Form (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple forms for {{ isFreezing ? 'freezing' : 'unfreezing' }}.
          </div>
          <div class="custom-dropdown-container">
            <div class="custom-dropdown-trigger d-flex justify-content-between align-items-center" 
                 (click)="toggleFreezeFormDropdown()">
              <span>{{ getFreezeFormLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showFreezeFormDropdown">
              <div *ngFor="let form of freezeAvailableForms" 
                   class="custom-dropdown-item d-flex align-items-center"
                   (click)="selectFreezeForm(form.id)">
                <input type="checkbox" 
                       class="form-check-input me-2"
                       [checked]="freezeFormCheckboxes[form.id] || false"
                       (click)="$event.stopPropagation()"
                       (change)="toggleFreezeFormCheckbox(form.id)">
                <span>{{ form.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="(freezeFormId && !hasAnyFreezeFormCheckboxChecked() && !hasAnyFreezeFolderCheckboxChecked())">
          <label class="form-label">Select Field (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple fields for {{ isFreezing ? 'freezing' : 'unfreezing' }}.
          </div>
          <div class="custom-dropdown-container">
            <div class="custom-dropdown-trigger d-flex justify-content-between align-items-center" 
                 (click)="toggleFreezeFieldDropdown()">
              <span>{{ getFreezeFieldLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showFreezeFieldDropdown">
              <div *ngFor="let field of freezeAvailableFields" 
                   class="custom-dropdown-item d-flex align-items-center"
                   (click)="selectFreezeField(field.id)">
                <input type="checkbox" 
                       class="form-check-input me-2"
                       [checked]="freezeFieldCheckboxes[field.id] || false"
                       (click)="$event.stopPropagation()"
                       (change)="toggleFreezeFieldCheckbox(field.id)">
                <span>{{ field.title }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="backToFreezeStep1()">
            Back
          </button>
          <button
            class="btn custom-button"
            (click)="goToFreezeStep3()"
            [disabled]="(!freezeFolderId && !hasAnyFreezeFolderCheckboxChecked())"
          >
            Next
          </button>
        </div>
      </ng-container>

      <!-- STEP 3: Credentials -->
      <ng-container *ngIf="freezeStep === 3">
        <div class="mb-3">
          <label class="form-label">Email:</label>
          <input
            type="email"
            class="form-control"
            [(ngModel)]="freezeEmail"
            placeholder="Enter your email"
            (keyup.enter)="authenticateAndApplyFreeze()"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">Password:</label>
          <div class="input-group">
            <input
              [type]="showFreezePassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="freezePassword"
              placeholder="Enter your password"
              (keyup.enter)="authenticateAndApplyFreeze()"
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="toggleFreezePasswordVisibility()"
            >
              <i
                class="bx"
                [class.bx-show]="!showFreezePassword"
                [class.bx-hide]="showFreezePassword"
              ></i>
            </button>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Reason:</label>
          <textarea
            class="form-control"
            [(ngModel)]="freezeReason"
            rows="3"
            [placeholder]="
              'Enter reason for ' + (isFreezing ? 'freezing' : 'unfreezing') + ' this item'
            "
          ></textarea>
        </div>
        <div *ngIf="freezeError" class="text-danger mb-3">
          {{ freezeError }}
        </div>

        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="backToFreezeStep2()">
            Back
          </button>
          <button
            class="btn custom-button"
            (click)="authenticateAndApplyFreeze()"
            [disabled]="!freezeEmail || !freezePassword || !freezeReason"
          >
            {{ isFreezing ? 'Freeze' : 'Unfreeze' }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Lock Modal -->
<div
  class="modal"
  *ngIf="showLockModal"
  (click)="closeLockDropdowns()"
>
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">Lock Configuration</h5>

      <ng-container *ngIf="lockStep === 1">
        <div class="alert alert-danger">
          <h6 class="mb-2"><strong>Terms and Conditions</strong></h6>
          <div class="mb-2"><strong>Important Warnings:</strong></div>
          <ul class="mb-3">
            <li>Once locked, this template item <strong>CANNOT</strong> be unlocked.</li>
            <li>You will <strong>NOT</strong> be able to edit structure, folders, forms, or fields.</li>
            <li>Only duplication will be allowed for locked templates.</li>
            <li>This action is <strong>IRREVERSIBLE</strong>.</li>
            <li>Make sure the template is complete and finalized before locking.</li>
          </ul>
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="lockTermsAccepted"
              [(ngModel)]="lockConfirmationAccepted"
            />
            <label class="form-check-label" for="lockTermsAccepted">
              I understand and accept the above terms and conditions
            </label>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="closeLockModal()">
            Cancel
          </button>
          <button
            class="btn custom-button btn-danger"
            (click)="goToLockStep2()"
            [disabled]="!lockConfirmationAccepted"
          >
            Next
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="lockStep === 2">
        <div class="mb-3">
          <label class="form-label">Selected Folder:</label>

          <!-- If opened from a folder's 3-dots menu, show folder name only (no picker) -->
          <ng-container *ngIf="lockOpenedFromFolderMenu; else lockFolderPicker">
            <input
              type="text"
              class="form-control"
              [value]="getFolderNameById(lockFolderId)"
              readonly
            />
          </ng-container>

          <!-- Default flow: allow selecting folders (including multi-select) -->
          <ng-template #lockFolderPicker>
            <div class="custom-dropdown-instruction">
              <i class="bx bx-info-circle"></i>
              <strong>Tip:</strong> Use the checkboxes to select multiple folders for locking.
            </div>
            <div class="custom-dropdown-container">
              <div
                class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
                (click)="toggleLockFolderDropdown()"
              >
                <span>{{ getLockFolderLabel() }}</span>
                <i class="bx bx-chevron-down"></i>
              </div>
              <div class="custom-dropdown-list" *ngIf="showLockFolderDropdown">
                <div
                  *ngFor="let folder of lockAvailableFolders"
                  class="custom-dropdown-item d-flex align-items-center"
                >
                  <input
                    type="checkbox"
                    class="form-check-input me-2"
                    [checked]="lockFolderCheckboxes[folder.id] || false"
                    (change)="toggleLockFolderCheckbox(folder.id)"
                    (click)="$event.stopPropagation()"
                  />
                  <span (click)="selectLockFolder(folder.id)">{{ folder.name }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="mb-3" *ngIf="(lockFolderId && !hasAnyLockFolderCheckboxChecked())">
          <label class="form-label">Select Form (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple forms for locking.
          </div>
          <div class="custom-dropdown-container">
            <div class="custom-dropdown-trigger d-flex justify-content-between align-items-center" 
                 (click)="toggleLockFormDropdown()">
              <span>{{ getLockFormLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showLockFormDropdown">
              <div *ngFor="let form of lockAvailableForms" 
                   class="custom-dropdown-item d-flex align-items-center">
                <input type="checkbox" 
                       class="form-check-input me-2"
                       [checked]="lockFormCheckboxes[form.id] || false"
                       (change)="toggleLockFormCheckbox(form.id)"
                       (click)="$event.stopPropagation()">
                <span (click)="selectLockForm(form.id)">{{ form.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-3" *ngIf="(lockFormId && !hasAnyLockFormCheckboxChecked() && !hasAnyLockFolderCheckboxChecked())">
          <label class="form-label">Select Field (optional):</label>
          <div class="custom-dropdown-instruction">
            <i class="bx bx-info-circle"></i>
            <strong>Tip:</strong> Use the checkboxes to select multiple fields for locking.
          </div>
          <div class="custom-dropdown-container">
            <div class="custom-dropdown-trigger d-flex justify-content-between align-items-center" 
                 (click)="toggleLockFieldDropdown()">
              <span>{{ getLockFieldLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showLockFieldDropdown">
              <div *ngFor="let field of lockAvailableFields" 
                   class="custom-dropdown-item d-flex align-items-center">
                <input type="checkbox" 
                       class="form-check-input me-2"
                       [checked]="lockFieldCheckboxes[field.id] || false"
                       (change)="toggleLockFieldCheckbox(field.id)"
                       (click)="$event.stopPropagation()">
                <span (click)="selectLockField(field.id)">{{ field.title }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <button class="btn custom-button me-2" (click)="backToLockStep1()">
            Back
          </button>
          <button
            class="btn custom-button btn-danger"
            (click)="goToLockStep3()"
            [disabled]="(!lockFolderId && !hasAnyLockFolderCheckboxChecked())"
          >
            Next
          </button>
        </div>
      </ng-container>

      <!-- STEP 3: Credentials -->
      <ng-container *ngIf="lockStep === 3">
        <div class="mb-3">
          <label class="form-label">Email:</label>
          <input
            type="email"
            class="form-control"
            [(ngModel)]="lockEmail"
            placeholder="Enter your email"
            (keyup.enter)="authenticateAndApplyLock()"
          />
        </div>
        <div class="mb-3">
          <label class="form-label">Password:</label>
          <div class="input-group">
            <input
              [type]="showLockPassword ? 'text' : 'password'"
              class="form-control"
              [(ngModel)]="lockPassword"
              placeholder="Enter your password"
              (keyup.enter)="authenticateAndApplyLock()"
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="toggleLockPasswordVisibility()"
            >
              <i
                class="bx"
                [class.bx-show]="!showLockPassword"
                [class.bx-hide]="showLockPassword"
              ></i>
            </button>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Reason:</label>
          <textarea
            class="form-control"
            [(ngModel)]="lockReason"
            rows="3"
            placeholder="Enter reason for locking this item"
          ></textarea>
        </div>
        <div *ngIf="lockError" class="text-danger mb-3">
          {{ lockError }}
        </div>

        <div class="d-flex justify-content-end">
          <button class="btn custom-button me-2" (click)="backToLockStep2()">
            Back
          </button>
          <button
            class="btn btn-danger"
            (click)="authenticateAndApplyLock()"
            [disabled]="!lockEmail || !lockPassword || !lockReason"
          >
            Lock
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>